import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LoadingImage from '../Images/loading.gif';
import ErrorPage from './Errorpage';

const MHint = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  
  useEffect(() => { 
    try {    
      window.history.pushState("you are being redirected...", "Redirect", "/redirect");
    } catch (err) {
      if (typeof console !== 'undefined') console.log(err);
    } 
    
    const queryParams = new URLSearchParams(location.search);
    const caeQMemID = queryParams.get('memqnxtid');
    const systemId = queryParams.get('SystemId');
    const userId = queryParams.get('UserId');
    const Module = queryParams.get('module') || '';
   
    fetchMHintURL(caeQMemID, systemId, userId, Module);
  }, [location]);

  const fetchMHintURL = async (caeQMemID, systemId, userId, Module) => {
    try {
      const response = await axios.get(`${API_URL}/api/MHint/GetMHintUrl`, {
        params: {
          caeQMemID: caeQMemID || '',
          systemId: systemId || '',
          userId: userId || '',
          Module: Module || 'Mhint'
        }
      });
      
      setLoading(false);
      
      // Use direct navigation instead of form submission
      if (response.data && response.data.url) {
        window.location.href = response.data.url;
      } else {
        setError('mhint');
      }
    } catch (error) {
      console.error('Error fetching MHint URL:', error);
      setError('mhint');
      setLoading(false);
    }
  };

  return (
    <div>
      <table style={{backgroundColor: 'transparent'}} cellPadding="0" cellSpacing="0">
        <tbody>
          <tr style={{height: '30%'}}>
            <td></td>
          </tr>
          <tr>
            <td style={{width: '30%'}}></td>
            <td align="center" style={{fontSize: 'x-large'}}>
              {error && <ErrorPage errorType="mhint" />}
            </td>
            <td style={{width: '30%'}}></td>
          </tr>
          <tr>
            <td style={{width: '50%'}}></td>
            <td align="center" style={{fontSize: 'large'}}>
              {loading && (
                <img src={LoadingImage} id="loadinggif" style={{alignContent: 'center'}} alt="Loading" />
              )}
            </td>
            <td style={{width: '50%'}}></td>
          </tr>
          <tr>
            <td style={{width: '30%'}}></td>
            <td align="center">
              <div style={{fontSize: 'larger'}}></div>
            </td>
            <td style={{width: '30%'}}></td>
          </tr>
          <tr style={{height: '30%'}}>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default MHint;